import { MDBDataTable } from "mdbreact";
import React, { useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { map_pos_status, position_type } from "../../constants/map_fields";
import EntriesSelector from "../tableServerPagination/entriesSelector";
import PaginationButtons from "../tableServerPagination/paginationButtons";

const MapList = function(props){

  const [size, setSize] = useState(100);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const searchTimeout = useRef(null);
  const user = JSON.parse(localStorage.getItem("authUser"));

  // P01021-142: búsqueda/filtro por servidor (sobre las ~1000 filas de rcs_map, no solo la
  // página cargada) — el buscador nativo de MDBDataTable (searching) se desactiva porque solo
  // filtraría dentro de la página actual, que es justo el problema reportado. Un cambio de
  // búsqueda, tipo o estado siempre resetea a la página 1 (el resultado filtrado puede tener
  // menos páginas que el listado completo).
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      props.getMap(user, size, 1, value, type, status);
    }, 400);
  };

  const handleTypeChange = (value) => {
    setType(value);
    setPage(1);
    props.getMap(user, size, 1, search, value, status);
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    setPage(1);
    props.getMap(user, size, 1, search, type, value);
  };

    return (
      <React.Fragment>
        <Row className="mb-3">
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="mapSearch">{props.t("Search")}</Label>
              <Input
                type="text"
                id="mapSearch"
                placeholder={props.t("Search")}
                defaultValue={search}
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="mapTypeFilter">{props.t("Tipo de posición")}</Label>
              <Input
                type="select"
                id="mapTypeFilter"
                value={type}
                onChange={(e) => handleTypeChange(e.target.value)}
              >
                <option value="">{props.t("Todos")}</option>
                {(props.positionTypes || []).map((code) => (
                  <option key={code} value={code}>
                    {position_type[code] || code}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-0">
              <Label htmlFor="mapStatusFilter">{props.t("Estado")}</Label>
              <Input
                type="select"
                id="mapStatusFilter"
                value={status}
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option value="">{props.t("Todos")}</option>
                {Object.keys(map_pos_status)
                  .filter((code) => code !== "null")
                  .map((code) => (
                    <option key={code} value={code}>
                      {map_pos_status[code].name}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <EntriesSelector
            label={props.t("Show positions")}
            size={size} setSize={setSize}
            setPage={setPage}
            getEntries={props.getMap}
            extraArgs={[search, type, status]}
        />
        <MDBDataTable responsive striped bordered data={props.maplist}
        paginationLabel={[props.t("Previous"), props.t("Next")]}
        entriesLabel={props.t("Show positions")}
        noRecordsFoundLabel={props.t("No matching records found")}
          infoLabel={[
              props.t("Showing"),
              props.t("to"),
              props.t("of"),
              props.t("entries"),
            ]}
        searching={false}
        paging={false}
        />
        <PaginationButtons
          size={size}
          page={page} setPage={setPage}
          totalPages={props.totalPages}
          getEntries={props.getMap}
          extraArgs={[search, type, status]}
          nextBtnLabel={props.t("Next")}
          prevBtnLabel={props.t("Previous")}
          t={props.t}
        />
      </React.Fragment>

    );
  }


export default (withNamespaces()(MapList));
